import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth/auth.service';

export const timeoutInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  authService.authTimeoutSubj.next(true);
  return next(req);
};